import React, { memo } from 'react';
import { HStack, Stack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
import { RichText } from 'Components/utility';
const InputErrorField = ({ testID, errorMessage }) => {
    if (!errorMessage) {
        return null;
    }
    return (React.createElement(HStack, { marginBottom: "$2" },
        React.createElement(Stack, { marginRight: "$2" },
            React.createElement(IconValidationInvalid, { color: "$support.danger.surfaceOnColorAlt", testID: `${testID}-icon` })),
        React.createElement(RichText, { color: "$support.danger.surfaceOnColorAlt", fontToken: "$bodySmall.default", testID: `${testID}-errorMessage`, text: errorMessage })));
};
export default memo(InputErrorField);
